import React from "react";
import Select from 'react-select';
import { Label } from "reactstrap";
import Validation from "../../utils/Validation";
import FIELD_TYPES from "./FieldTypes";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FileUpload from "../fileupload";
import { isFunction } from "lodash";
import TagsInput from 'react-tagsinput';
import Switch from "react-switch";
import TimePicker from "react-time-picker";
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import DateTimePicker from "react-datetime-picker";
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import FileUploadAll from "../fileupload/fileuplaodall";
import ResearchWorkUpload from "../fileupload/researchworkupload";
import { AutoComplete, DatePicker } from "antd";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { on } from "events";
import SignatureCapture from "../captures/SignatureCapture";
import ImageCapture from "../captures/ImageCapture";
import VideoCapture from "../captures/VideoCapture";
import AudioCapture from "../captures/AudioCapture";
import dayjs from 'dayjs';

// TODO disable, readonly prop integrations
interface Props {
    id?: string;
    label?: React.ReactNode;
    labelIcon?: React.ReactNode;
    placeholder?: string;
    name?: string;
    picker?: string;
    onChange?: (event: React.FormEvent<HTMLInputElement>) => void | any;
    onClear?: (event: React.FormEvent<HTMLInputElement>) => void | any;
    className?: string;
    type?: number;
    inputType?: string;
    isMandatory?: boolean;
    isDisabled?: boolean;
    value?: any;
    maxLength?: string | number;
    isNumber?: boolean;
    touched?: boolean;
    error?: boolean | string;
    values?: Array<Object> | object;
    isListed?: boolean,
    isTerms?: boolean,
    perRow?: string,
    dateFormat?: string;
    todayButton?: boolean;
    minDate?: Date;
    maxDate?: Date;
    excludeDates?: Array<Date>;
    acceptFiles?: String;
    maxLimit?: number;
    icon?: String;
    iconClick?: (event) => void | any;
    showMonthYearPicker?: boolean;
    timeInterval?: number;
    showTimeSelect?: boolean;
    showTimeSelectOnly?: boolean;
    showMonthPicker?: boolean;
    showYearPicker?: boolean;
    addButton?: string;
    onAdd?: (event) => void | any;
    menuPlacement?: string;
    onBlur?: (event) => void | any;
    onKeyUp?: (event) => void | any;
    onFocus?: (event) => void | any;
    isRemove?: boolean;
    onRemove?: (event) => void | any;
    clearUpload?: boolean;
    isPreview?: boolean;
    rowValues?: Array<Object> | object;
    showSeconds?: boolean;
    handleMenuScrollToBottom?: () => void;
    isLoadingMore?: boolean;
    isextract?: boolean;
}

const FieldItem: React.FunctionComponent<Props> = (props: any) => {
    const {
        id,
        label,
        labelIcon,
        placeholder,
        name,
        picker,
        onChange,
        onClear,
        className,
        type,
        inputType,
        isMandatory,
        isDisabled,
        value,
        defaultvalues,
        maxLength,
        isNumber,
        touched,
        error,
        values,
        isListed,
        isTerms,
        perRow,
        dateFormat,
        timeFormat,
        todayButton,
        minDate,
        maxDate,
        excludeDates,
        icon,
        iconClick,
        showMonthYearPicker,
        timeInterval,
        showTimeSelect,
        showTimeSelectOnly,
        showMonthPicker,
        showYearPicker,
        addButton,
        onAdd,
        menuPlacement,
        onFocus,
        isRemove,
        onKeyUp,
        clearUpload,
        isPreview,
        rowValues,
        showSeconds,
        handleMenuScrollToBottom,
        isLoadingMore,
        isextract,
    } = props;

    const [showPassword, setShowPassword] = React.useState(false);

    const customOption = (props) => {
        const { data, innerRef, innerProps } = props;

        return (
            <div
                ref={innerRef}
                {...innerProps}
                data-tooltip-id={"my-tooltip"}
                data-tooltip-content="sadfdf"
                style={{ padding: "8px", cursor: "pointer" }}
            >
                {data.label}
                <ReactTooltip id={"my-tooltip"} place="right" />
            </div>
        );
    };


    const options = [
        { value: '' },
    ];


    const onBlur = (e: any) => {
        if (onChange) {
            onChange(e, { isTouched: true });
        }

        if (isFunction(props.onBlur)) {
            props.onBlur(e);
        }
    };

    const onReset = (e) => {
        return "";
    }

    const onKeyUpEvent = (e: any) => {
        if (onKeyUp && e.keyCode === 13)
            onKeyUp();
    }

    const numberValid = (event: any) => {
        const value = event?.target?.value || event;
        let pattern = new RegExp(/^[0-9 ]+$/i);
        if (!pattern.test(value) && value !== "") {
            return false;
        } else {
            onChange(event);
        }
        // console.log(value);
    };

    const getInputContainer = () => {
        return (
            <div className="form-group mb-3">
                {label ? (
                    <div className="form-label">
                        {label.toString()}
                        {labelIcon && <i className={`icon ${labelIcon}`} />}
                        {isMandatory && (
                            <label className="specialcharacter-required">*</label>
                        )}
                    </div>
                ) : ""}
                <div className="input-container">{getInput()}</div>
                <div className="text-help">
                    {touched && error ? (
                        <>
                            <i className="icon icon-error" /> {error}
                        </>
                    ) : <></>}
                </div>
            </div>
        );
    };

    const checkValid = (value) => {
        return value
    }

    const renderInput = () => {
        return (
            <div className="icon-position">
                <input
                    value={value}
                    name={name}
                    placeholder={
                        placeholder ? Validation.capitalizeFirstLetter(placeholder) : ""
                    }
                    type={isNumber ? "number" : inputType}
                    className={`text-input ${className} ${(touched && error) ? 'error-field' : ''}`}
                    onChange={(e) => onChange(e.target.value)}
                    maxLength={maxLength ? maxLength : ""}
                    disabled={isDisabled}
                    style={isDisabled ? { backgroundColor: "#ccc" } : {}}
                    onBlur={(e) => onBlur(e.target.value)}
                />
                {icon && <i className={`icon icon-${icon}`} onClick={() => isFunction(iconClick) && iconClick()} />}
            </div>
        )
    }


    /**
     * render input auto complete
     */
    const renderInputAutoComplete = () => {
        return (
            <div >
                <AutoComplete
                    style={{ width: "100%", padding: "5px 0px" }}
                    options={values}
                    placeholder="Field Type"
                    defaultValue={value}
                    value={value}
                    filterOption={true}
                    onChange={(e) => onChange(e)}
                />
            </div>
        )
    }

    /**
   * render input instruction
   */
    const renderInputInstruction = () => {
        return (
            <div style={{ fontSize: "20px" }}>
                {value}
            </div>
        )
    }

    /**
     * render input number
     */
    const renderInputNumber = () => {
        return (
            <div className="icon-position">
                <input
                    value={value}
                    name={name}
                    placeholder={
                        placeholder ? Validation.capitalizeFirstLetter(placeholder) : ""
                    }
                    type="number"
                    className={`text-input ${className} ${(touched && error) ? 'error-field' : ''}`}
                    onChange={(e) => onChange(e.target.value)}
                    maxLength={maxLength ? maxLength : ""}
                    disabled={isDisabled}
                    onBlur={(e) => onBlur(e)}
                />
                {icon && <i className={`icon icon-${icon}`} onClick={() => isFunction(iconClick) && iconClick()} />}
            </div>
        )
    }

    const renderTextArea = () => {
        return (
            <textarea
                value={value}
                name={name}
                placeholder={
                    placeholder ? Validation.capitalizeFirstLetter(placeholder) : ""
                }
                className={`text-area ${className} ${(touched && error) ? 'error-field' : ''}`}
                onChange={(e) => onChange(e.target.value)}
                disabled={isDisabled}
                onBlur={(e) => onBlur(e.target.value)}
                onFocus={() => isFunction(onFocus()) && onFocus()}
            />
        )
    }

    const renderDropdown = () => {
        return (
            <div className="custom-dropdown">
                <Select
                    className={`basic-single ${className} ${(touched && error) ? 'error-field' : ''}`}
                    classNamePrefix="select"
                    placeholder={
                        placeholder ? Validation.capitalizeFirstLetter(placeholder) : "Select"
                    }
                    isDisabled={isDisabled}
                    isSearchable={true}
                    defaultValue={value}
                    value={value}
                    isClearable={false}
                    options={values}
                    menuPlacement={menuPlacement}
                    menuPosition="fixed"
                    onChange={(e) => onChange(e)}
                // onBlur={(e) => onBlur(e.target.value)}
                />

            </div>
        );
    }

    const renderDropdownTooltip = () => {
        return (
            <div className="custom-dropdown">
                <Select
                    className={`basic-singletip ${className} ${(touched && error) ? 'error-field' : ''}`}
                    classNamePrefix="select"
                    placeholder={
                        placeholder ? Validation.capitalizeFirstLetter(placeholder) : "Select"
                    }
                    isDisabled={isDisabled}
                    isSearchable={true}
                    value={value}
                    isClearable={false}
                    options={values}
                    menuPlacement={menuPlacement}
                    menuPosition="fixed"
                    onChange={(e) => onChange(e)}
                    onBlur={(e) => onBlur(e.target.value)}
                    components={{
                        SingleValue: ({ data, ...props }) => (
                            <span
                                {...props.innerProps}
                                data-tooltip-id={id}
                                data-tooltip-content={value.label}
                                style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "90%", // Restrict text to fit within container
                                    display: "block",
                                }}
                            >
                                {data.label}
                            </span>
                        ),
                    }}
                    styles={{
                        control: (provided) => ({
                            ...provided,
                            minHeight: "50px",
                            height: "50px",
                            display: "flex",
                            alignItems: "center", // Center content vertically
                            padding: "0 8px",
                        }),
                        valueContainer: (provided) => ({
                            ...provided,
                            padding: "0px", // Remove extra padding around selected value
                            height: "50px",
                            display: "flex",
                            alignItems: "center", // Ensure the text is vertically centered
                        }),
                        singleValue: (provided) => ({
                            ...provided,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100%",
                            display: "flex",
                            alignItems: "center", // Center text inside the box
                        }),
                        option: (provided) => ({
                            ...provided,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100%", // Keep text inside the option box
                            height: "50px",
                            display: "flex",
                            alignItems: "center", // Center text in each option
                        }),
                        indicatorsContainer: (provided) => ({
                            ...provided,
                            height: "50px",
                            display: "flex",
                            alignItems: "center",
                        }),
                    }}

                />


                <ReactTooltip id={id} place="bottom" className="tooltip-custom" />

            </div>
        );
    }


    const renderMultiSelectDropdown = () => {
        return (
            <div className="custom-dropdown d-flex m-0">
                <Select
                    className={`w-100 basic-multi ${className} ${(touched && error) ? 'error-field' : ''}`}
                    classNamePrefix="select"
                    defaultValue={value}
                    value={value}
                    isMulti={true}
                    isDisabled={isDisabled}
                    isClearable={false}
                    isSearchable={true}
                    options={values}
                    menuPosition="fixed"
                    components={addButton && { DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                    onChange={(e) => onChange(e)}
                    onMenuScrollToBottom={handleMenuScrollToBottom}
                    isLoading={isLoadingMore}
                />
                {addButton &&
                    <div className="button-poistion" onClick={() => onAdd()}>
                        <div className="icon"><i className="icon icon-add_circle"></i></div>
                        <div className="button-text">{addButton}</div>
                    </div>
                }
            </div>
        );
    }

    const renderRadioButton = () => {
        return (
            <div className={`custom-radio ${isListed ? 'row' : ''}`}>
                {values.map((obj, index) => (
                    <div key={index} className={`align-center mb-2 ${isDisabled ? 'pe-none' : ''} ${isListed ? 'pl-3 pr-3' : ''}`}>
                        <img src={`${process.env.PUBLIC_URL}/images/${value === obj.value ? "radio_selected" : "radio_idle"}.svg`} alt="radio" onClick={() => {
                            if (value === obj.value) {
                                onChange(null);
                            } else {
                                onChange(obj.value);
                            }
                        }} />
                        <Label check>{obj.label}</Label>
                    </div>
                ))}
            </div>
        )
    }

    const renderPermissionRadioButton = () => {
        return (
            <div className={`custom-radio-per ${isListed ? 'row' : ''}`}>
                {values.map((obj, index) => (
                    <div key={index} className={`align-center mb-2 ${isDisabled ? 'pe-none' : ''} ${isListed ? 'pl-3 pr-3' : ''}`}>
                        <img src={`${process.env.PUBLIC_URL}/images/${value === obj.value ? "radio_selected" : "radio_idle"}.svg`} alt="radio" onClick={(e) => onChange(obj.value)} />
                        <Label check style={{ padding: "0px 10px" }}>{obj.label}</Label>
                    </div>
                ))}
            </div>
        )
    }

    const renderCheckbox = () => {
        const submitData = (e) => {
            const currentValue = Array.isArray(value) ? [...value] : [];
            if (currentValue.length > 0) {
                // console.log(currentValue)
                let index = currentValue.indexOf(e);
                if (index >= 0) {
                    currentValue.splice(index, 1);
                } else {
                    currentValue.push(e);
                }
                onChange(currentValue);
            } else {
                onChange([e]);
            }
        }
        return (
            <div className={isTerms ? `custom-terms` : `custom-checkbox ${isListed ? 'row' : ''}`}>
                {values.map((obj, index) => {
                    const selectedImage = ((value && value.includes(obj.value)) ? 'checkbox_selected' : 'checkbox_idle')
                    return (
                        <div key={index} className={`align-center mb-2 ${isListed ? 'pl-3 pr-3 ' + perRow : ''}`}>
                            <img src={`${process.env.PUBLIC_URL}/images/${selectedImage}.svg`} alt="checkbox" onClick={() => isDisabled ? "" : submitData(obj.value)} />
                            <Label check>{obj.label}</Label>
                        </div>
                    )
                })}
            </div>
        )
    }

    const renderCheckboxGrid = () => {
        const columns = values?.map(col => ({ id: col, label: col }));
        const rows = rowValues?.map(row => ({ id: row, label: row }));

        const isCellSelected = (rowId, colId) => {
            if (!value || !Array.isArray(value)) return false;
            const rowEntry = value.find(item => item.rowKey === rowId);
            return rowEntry && Array.isArray(rowEntry.value) && rowEntry.value.includes(colId);
        };

        // Check if entire column is selected
        const isColumnSelected = (colId) => {
            if (!rows || rows.length === 0) return false;
            return rows.every(row => isCellSelected(row.id, colId));
        };

        // Toggle entire column
        const toggleColumn = (colId) => {
            if (isDisabled) return;

            const allSelected = isColumnSelected(colId);
            let newValue = Array.isArray(value) ? [...value] : [];

            rows.forEach(row => {
                const rowIndex = newValue.findIndex(item => item.rowKey === row.id);

                if (allSelected) {
                    // Deselect entire column - remove colId from all rows
                    if (rowIndex >= 0) {
                        const rowEntry = { ...newValue[rowIndex] };
                        const valueArray = Array.isArray(rowEntry.value) ? [...rowEntry.value] : [];
                        const colIndex = valueArray.indexOf(colId);

                        if (colIndex >= 0) {
                            valueArray.splice(colIndex, 1);

                            if (valueArray.length === 0) {
                                newValue.splice(rowIndex, 1);
                            } else {
                                newValue[rowIndex] = { ...rowEntry, value: valueArray };
                            }
                        }
                    }
                } else {
                    // Select entire column - add colId to all rows
                    if (rowIndex >= 0) {
                        const rowEntry = { ...newValue[rowIndex] };
                        const valueArray = Array.isArray(rowEntry.value) ? [...rowEntry.value] : [];

                        if (!valueArray.includes(colId)) {
                            valueArray.push(colId);
                            newValue[rowIndex] = { ...rowEntry, value: valueArray };
                        }
                    } else {
                        newValue.push({ rowKey: row.id, value: [colId] });
                    }
                }
            });

            onChange(newValue);
        };

        const toggleCell = (rowId, colId) => {
            if (isDisabled) return;
            let newValue = Array.isArray(value) ? [...value] : [];
            const rowIndex = newValue.findIndex(item => item.rowKey === rowId);

            if (rowIndex >= 0) {
                const rowEntry = { ...newValue[rowIndex] };
                const valueArray = Array.isArray(rowEntry.value) ? [...rowEntry.value] : [];
                const colIndex = valueArray.indexOf(colId);

                if (colIndex >= 0) {
                    valueArray.splice(colIndex, 1);
                } else {
                    valueArray.push(colId);
                }

                newValue[rowIndex] = { ...rowEntry, value: valueArray };

                if (valueArray.length === 0) {
                    newValue.splice(rowIndex, 1);
                }
            } else {
                newValue.push({ rowKey: rowId, value: [colId] });
            }

            onChange(newValue);
        };

        return (
            <div className="custom-checkbox-grid-container">
                <div className="custom-checkbox-grid">
                    <div className="grid-header-row">
                        <div className="grid-left-label">
                            Apply All
                        </div>
                        {columns.map((column, colIndex) => (
                            <div key={`col-${colIndex}`} className="grid-header-cell">
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/${isColumnSelected(column.id) ? 'checkbox_selected' : 'checkbox_idle'
                                        }.svg`}
                                    alt="Select column"
                                    onClick={() => toggleColumn(column.id)}
                                    style={{
                                        cursor: isDisabled ? 'default' : 'pointer',
                                        marginBottom: '4px',
                                        display: 'block'
                                    }}
                                />
                                <div>{column.label}</div>
                            </div>
                        ))}
                    </div>

                    {rows.map((row, rowIndex) => (
                        <div key={`row-${rowIndex}`} className="grid-row">
                            <div className="grid-row-label">{row.label}</div>
                            {columns.map((column, colIndex) => {
                                const selectedImage = isCellSelected(row.id, column.id)
                                    ? 'checkbox_selected'
                                    : 'checkbox_idle';

                                return (
                                    <div key={`cell-${rowIndex}-${colIndex}`} className="grid-cell">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/${selectedImage}.svg`}
                                            alt="checkbox"
                                            onClick={() => toggleCell(row.id, column.id)}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const renderRadioButtonGrid = () => {
        const columns = values?.map(col => ({
            id: col,
            label: col
        }));

        const rows = rowValues?.map(row => ({
            id: row,
            label: row
        }));

        const isCellSelected = (rowId, colId) => {
            if (!value || !Array.isArray(value)) return false;

            // Find the row entry in the array and check if its value matches the column
            const rowEntry = value.find(item => item.rowKey === rowId);
            return rowEntry && rowEntry.value === colId;
        };

        // Check if entire column is selected
        const isColumnSelected = (colId) => {
            if (!rows || rows.length === 0) return false;
            return rows.every(row => isCellSelected(row.id, colId));
        };

        // Select entire column
        const selectColumn = (colId) => {
            if (isDisabled) return;

            let newValue = Array.isArray(value) ? [...value] : [];

            // Set all rows to this column value
            rows.forEach(row => {
                const existingRowIndex = newValue.findIndex(item => item.rowKey === row.id);

                if (existingRowIndex >= 0) {
                    newValue[existingRowIndex] = { rowKey: row.id, value: colId };
                } else {
                    newValue.push({ rowKey: row.id, value: colId });
                }
            });

            onChange(newValue);
        };

        const selectCell = (rowId, colId) => {
            if (isDisabled) return;

            let newValue = Array.isArray(value) ? [...value] : [];

            // Find if the row already exists in the array
            const existingRowIndex = newValue.findIndex(item => item.rowKey === rowId);

            if (existingRowIndex >= 0) {
                // Update existing row
                newValue[existingRowIndex] = { rowKey: rowId, value: colId };
            } else {
                // Add new row
                newValue.push({ rowKey: rowId, value: colId });
            }

            onChange(newValue);
        };

        return (
            <div className="custom-radio-grid-container">
                <div className="custom-radio-grid">
                    <div className="grid-header-row">
                        <div className="grid-left-label">
                            Apply All
                        </div>
                        {columns.map((column, colIndex) => (
                            <div key={`col-${colIndex}`} className="grid-header-cell">
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/${isColumnSelected(column.id) ? 'radio_selected' : 'radio_idle'
                                        }.svg`}
                                    alt="Select column"
                                    onClick={() => selectColumn(column.id)}
                                    style={{
                                        cursor: isDisabled ? 'default' : 'pointer',
                                        marginBottom: '4px',
                                        display: 'block'
                                    }}
                                />
                                <div>{column.label}</div>
                            </div>
                        ))}
                    </div>

                    {rows.map((row, rowIndex) => (
                        <div key={`row-${rowIndex}`} className="grid-row">
                            <div className="grid-row-label">{row.label}</div>
                            {columns.map((column, colIndex) => {
                                const selectedImage = isCellSelected(row.id, column.id)
                                    ? 'radio_selected'
                                    : 'radio_idle';

                                return (
                                    <div key={`cell-${rowIndex}-${colIndex}`} className="grid-cell">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/${selectedImage}.svg`}
                                            alt="radio"
                                            onClick={() => selectCell(row.id, column.id)}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const renderTextboxGrid = () => {
        const columns = values?.map(col => ({
            id: col,
            label: col
        }));

        const rows = rowValues?.map(row => ({
            id: row,
            label: row
        }));

        // For array-based value format:
        // [{ rowKey: "a", colKey: "c1", value: "ac1" }, ...]

        // Handle text input change
        const handleTextChange = (rowId, colId, text) => {
            if (isDisabled) return;

            // Create a new copy of the value array, or start with empty array
            let newValueArray = Array.isArray(value) ? [...value] : [];

            // Find if this cell already exists in the array
            const existingIndex = newValueArray.findIndex(
                item => item.rowKey === rowId && item.colKey === colId
            );

            if (existingIndex !== -1) {
                // Update existing cell value
                newValueArray[existingIndex] = {
                    ...newValueArray[existingIndex],
                    value: text
                };
            } else {
                // Add new cell value
                newValueArray.push({
                    rowKey: rowId,
                    colKey: colId,
                    value: text
                });
            }

            onChange(newValueArray);
        };

        // Get the current value for a cell
        const getCellValue = (rowId, colId) => {
            if (!Array.isArray(value)) return '';

            const cellData = value.find(
                item => item.rowKey === rowId && item.colKey === colId
            );

            return cellData ? cellData.value : '';
        };

        return (
            <div className="custom-textbox-grid-container">
                <div className="custom-textbox-grid">
                    {/* Header row with column labels */}
                    <div className="grid-header-row">
                        <div className="grid-empty-cell"></div>
                        {columns.map((column, colIndex) => (
                            <div key={`col-${colIndex}`} className="grid-header-cell">
                                {column.label}
                            </div>
                        ))}
                    </div>

                    {/* Grid rows */}
                    {rows.map((row, rowIndex) => (
                        <div key={`row-${rowIndex}`} className="grid-row">
                            <div className="grid-row-label">{row.label}</div>
                            {columns.map((column, colIndex) => (
                                <div key={`cell-${rowIndex}-${colIndex}`} className="grid-cell">
                                    <div className="icon-position">
                                        <input
                                            value={getCellValue(row.id, column.id)}
                                            placeholder="Enter"
                                            type="text"
                                            className="text-input"
                                            onChange={(e) => handleTextChange(row.id, column.id, e.target.value)}
                                            disabled={isDisabled}
                                            style={isDisabled ? { backgroundColor: "#ccc" } : {}}
                                            onBlur={(e) => onBlur && onBlur(e)}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        );
    };


    const renderSearch = () => {
        return (
            <div className="search-field">
                <input
                    value={value}
                    name={name}
                    placeholder={
                        placeholder ? Validation.capitalizeFirstLetter(placeholder) : ""
                    }
                    type="text"
                    className={`text-input ${className} ${(touched && error) ? 'error-field' : ''} ${value ? 'has-content' : ""}`}
                    onChange={(e) => (isNumber ? numberValid(e.target.value) : onChange(e.target.value))}
                    maxLength={maxLength ? maxLength : ""}
                    disabled={isDisabled}
                    onBlur={(e) => onBlur(e.target.value)}
                    onKeyUp={(e) => onKeyUpEvent(e)}
                    onReset={(e) => onReset(e)}
                />
                <div className="search-icon"><i className="icon icon-search"></i></div>
                <div className="close-icon" onClick={(e) => onChange("")}><i className="icon icon-close"></i></div>

            </div>
        )
    }

    const renderDatepicker = () => {
        return (
            <div className="custom-datepicker">
                <ReactDatePicker
                    selected={value == "Invalid Date" ? null : value}
                    name={name}
                    className={`text-input ${className} ${(touched && error) ? 'error-field' : ''}`}
                    onChange={(e: any) => onChange(e)}
                    placeholderText={placeholder || "DD - MMM - YYYY"}
                    disabled={isDisabled}
                    dateFormat={dateFormat}
                    todayButton={todayButton ? 'Today' : false}
                    minDate={minDate}
                    maxDate={maxDate}
                    excludeDates={excludeDates}
                    disabledKeyboardNavigation
                    formatWeekDay={(nameOfDay: any) => nameOfDay.substr(0, 3)}
                    showYearDropdown
                    showMonthYearPicker={showMonthYearPicker}
                    timeInterval={timeInterval}
                    showTimeSelect={showTimeSelect}
                    showTimeSelectOnly={showTimeSelectOnly}
                    showMonthPicker={showMonthPicker}
                    showYearPicker={showYearPicker}
                />
            </div>
        )
    }

    const renderDatepickernew = () => {
        return (
            <div className="custom-datepicker">
                <DatePicker
                    value={value ? dayjs(value) : null}
                    name={name}
                    size="large"
                    className={`text-input ${className} ${(touched && error) ? 'error-field' : ''}`}
                    onChange={(e: any) => onChange(e)}
                    placeholder={placeholder || "DD - MM - YYYY"}
                    disabled={isDisabled}
                    format={picker ? 'MM/YYYY' : 'DD/MM/YYYY'}
                //picker={picker ? picker : "week"}                         
                />
            </div>
        )
    }

    const renderTimepicker = () => {
        const handleSetCurrentTime = () => {
            const now = new Date();

            const formattedTime = now
                .toLocaleTimeString("en-GB", { hour12: false });

            onChange(formattedTime);
        };

        const handleChange = (e: any) => {
            if (!e) {
                onChange(null);
                return;
            }

            let formattedTime = e;

            if (!showSeconds) {
                if (/^\d{1,2}:\d{2}$/.test(formattedTime)) {
                    formattedTime = `${formattedTime}:00`;
                }
            }

            onChange(formattedTime);
        };

        return (
            <div className="custom-datepicker custom-time-picker">
                <TimePicker
                    format={showSeconds ? "h:mm:ss a" : "h:mm a"}
                    amPmAriaLabel="AM"
                    maxDetail={showSeconds ? "second" : "minute"}
                    value={value}
                    disableClock={true}
                    onChange={handleChange}
                />
                <button
                    type="button"
                    onClick={handleSetCurrentTime}
                    className="set-current-time-btn"
                >
                    Set Current Time
                </button>
            </div>
        );
    };

    const renderDateTimepicker = () => {
        return (
            <div className="custom-datepicker">
                {/* <DateTimePicker
                    format="y-MM-dd h:mm a"
                    disableClock={true}
                    value={value}
                    onChange={(e: any) => onChange(e)}
                    disabled={isDisabled}
                /> */}
                <DatePicker
                    showTime={{
                        format: 'h:mm a',
                        use12Hours: true
                    }}
                    format="YYYY-MM-DD h:mm a"
                    value={value ? dayjs(value) : null}
                    onChange={(date) => onChange(date ? date.toDate() : null)}
                    disabled={isDisabled}
                    placeholder="Select date and time"
                />

            </div>
        )
    }

    function defaultRenderTag(multiProps) {
        let { tag, key, disabled, classNameRemove, onRemove, getTagDisplayValue, ...other } = multiProps;
        return (
            <span key={key} {...other}>
                {getTagDisplayValue(tag)}
                <a className={classNameRemove} onClick={(e) => props.onRemove(key)} />
            </span>
        )
    }

    const renderMultiText = () => {
        return (
            isRemove ?
                <TagsInput
                    value={value}
                    name={name}
                    className={`multi-text ${className} ${(touched && error) ? 'error-field' : ''}`}
                    onChange={(e) => onChange(e)}
                    disabled={isDisabled}
                    addKeys={[13]}
                    onlyUnique={true}
                    inputFieldPosition="bottom"
                    addOnBlur={true}
                    inputProps={{ placeholder: placeholder ? Validation.capitalizeFirstLetter(placeholder) : "" }}
                    renderTag={(props) => defaultRenderTag(props)}
                /> :
                <TagsInput
                    value={value}
                    name={name}
                    className={`multi-text ${className} ${(touched && error) ? 'error-field' : ''}`}
                    onChange={(e) => onChange(e)}
                    disabled={isDisabled}
                    addKeys={[13]}
                    onlyUnique={true}
                    inputFieldPosition="bottom"
                    addOnBlur={true}
                    inputProps={{ placeholder: placeholder ? Validation.capitalizeFirstLetter(placeholder) : "" }}
                />
        )
    }

    const renderBoolean = () => {
        return (
            <Switch
                checked={value}
                onChange={(e) => onChange(e)}
                disabled={isDisabled}
                onColor="#86d3ff"
                offHandleColor="#ccc"
                onHandleColor="#2693e6"
                handleDiameter={18}
                uncheckedIcon={false}
                checkedIcon={false}
                height={15}
                width={40}
                className="react-switch"
                id="material-switch"
            />
        )
    }

    const isPasswordField = type === FIELD_TYPES.PASSWORD;

    const resolvedInputType =
        isPasswordField
            ? isPreview
                ? "password"
                : showPassword
                    ? "text"
                    : "password"
            : inputType;

    const resolvedIcon =
        isPasswordField && !isPreview
            ? showPassword
                ? "lock_open"
                : "lock"
            : null;

    const resolvedIconClick =
        isPasswordField && !isPreview
            ? () => setShowPassword(prev => !prev)
            : undefined;

    const renderPassword = () => {
        return (
            <div className="icon-position password-field">
                <input
                    value={value || ""}
                    name={`field_${name}`}
                    placeholder={
                        placeholder
                            ? Validation.capitalizeFirstLetter(placeholder)
                            : ""
                    }
                    type={resolvedInputType}
                    className={`text-input ${className} ${touched && error ? "error-field" : ""}`}
                    onChange={(e) => onChange(e.target.value)}
                    maxLength={maxLength}
                    disabled={isDisabled}
                    style={isDisabled ? { backgroundColor: "#ccc" } : {}}
                    onBlur={onBlur}
                    autoComplete="new-password"
                    data-lpignore="true"
                    data-form-type="other"
                />

                {resolvedIcon && (
                    <i className={`icon icon-${resolvedIcon}`} onClick={resolvedIconClick} />
                )}

            </div>
        );
    };

    const getInput = () => {
        switch (type) {
            case FIELD_TYPES.TEXT:
                return (
                    renderInput()
                );
            case FIELD_TYPES.NUMBER:
                return (
                    renderInputNumber()
                );
            case FIELD_TYPES.INPUT_INSTRUCTION:
                return (
                    renderInputInstruction()
                );
            case FIELD_TYPES.TEXT_AREA:
                return (
                    renderTextArea()
                );
            case FIELD_TYPES.DROP_DOWN:
                return (
                    renderDropdown()
                );
            case FIELD_TYPES.DROPDOWN_TOOLTIP:
                return (
                    renderDropdownTooltip()
                );
            case FIELD_TYPES.MULTI_SELECT:
                return (
                    renderMultiSelectDropdown()
                );
            case FIELD_TYPES.RADIO_BUTTON:
                return (
                    renderRadioButton()
                )
            case FIELD_TYPES.RADIO_BUTTON_PER:
                return (
                    renderPermissionRadioButton()
                )
            case FIELD_TYPES.CHECK_BOX:
                return (
                    renderCheckbox()
                )
            case FIELD_TYPES.CHECK_BOX_GRID:
                return (
                    renderCheckboxGrid()
                )
            case FIELD_TYPES.RADIO_BUTTON_GRID:
                return (
                    renderRadioButtonGrid()
                )
            case FIELD_TYPES.TEXT_BOX_GRID:
                return (
                    renderTextboxGrid()
                )
            case FIELD_TYPES.SEARCH:
                return (
                    renderSearch()
                )
            case FIELD_TYPES.DATE_PICKER:
                return (
                    renderDatepicker()
                );
            case FIELD_TYPES.SIGNATURE_CAPTURE:
                return (
                    <SignatureCapture {...props} isDisabled={isDisabled} onUpload={(data) => onChange(data)} isPreview={isPreview} />
                );
            case FIELD_TYPES.IMAGE_CAPTURE:
                return (
                    <ImageCapture {...props} isDisabled={isDisabled} onUpload={(data) => onChange(data)} isPreview={isPreview} />
                );
            case FIELD_TYPES.VIDEO_CAPTURE:
                return (
                    <VideoCapture {...props} isDisabled={isDisabled} onUpload={(data) => onChange(data)} isPreview={isPreview} />
                );
            case FIELD_TYPES.AUDIO_CAPTURE:
                return (
                    <AudioCapture {...props} isDisabled={isDisabled} onUpload={(data) => onChange(data)} isPreview={isPreview} />
                );
            case FIELD_TYPES.FILE_UPLOAD:
                return (
                    <FileUpload {...props} isDisabled={isDisabled} onUpload={(data) => onChange(data)} clearUpload={clearUpload} />
                );
            case FIELD_TYPES.FILE_UPLOAD_ALL:
                return (
                    <FileUploadAll {...props} isDisabled={isDisabled} onUpload={(data) => onChange(data)} />
                );
            case FIELD_TYPES.RESEARCHWORK_UPLOAD:
                return (
                    <ResearchWorkUpload {...props} isDisabled={isDisabled} onUpload={(data) => onChange(data)} />
                );
            case FIELD_TYPES.MULTI_TEXT:
                return (
                    renderMultiText()
                )
            case FIELD_TYPES.BOOLEAN:
                return (
                    renderBoolean()
                )
            case FIELD_TYPES.TIME_PICKER:
                return (
                    renderTimepicker()
                )
            case FIELD_TYPES.DATE_TIME_PICKER:
                return (
                    renderDateTimepicker()
                )
            case FIELD_TYPES.TEXT_AUTOCOMPLETE:
                return (
                    renderInputAutoComplete()
                )
            case FIELD_TYPES.DATEPICKER_NEW:
                return (
                    renderDatepickernew()
                )
            case FIELD_TYPES.PASSWORD:
                return (
                    renderPassword()
                )
            default:
                return (
                    renderInput()
                );
        }
    };

    const getFinalData = () => {
        // use this function to update parent div style
        return <div className="field-items">{getInputContainer()}</div>;
    };

    return getFinalData();
};

FieldItem.defaultProps = {
    label: "",
    labelIcon: "",
    placeholder: "",
    name: "",
    onChange: (event) => { },
    onClear: (event) => { },
    className: "",
    type: FIELD_TYPES.TEXT,
    inputType: 'text',
    values: [],
    value: '',
    isMandatory: false,
    isDisabled: false,
    touched: false,
    error: false,
    isListed: false,
    perRow: '',
    dateFormat: 'dd/MM/yyyy',
    todayButton: false,
    excludeDates: [],
    acceptFiles: 'pdf|png|csv|jpeg|jpg|svg',
    iconClick: (event) => { },
    showMonthYearPicker: false,
    timeInterval: 5,
    showTimeSelect: false,
    showTimeSelectOnly: false,
    showMonthPicker: false,
    showYearPicker: false,
    addButton: '',
    onAdd: (event) => { },
    menuPlacement: 'bottom',
    onBlur: () => { },
    onKeyUp: () => { },
    onFocus: () => { },
    isRemove: false,
    onRemove: () => { }
};

export default FieldItem;